// wp-icons — Loading & Misc (4)
// MapPin lebt in craft.js.
import { createWpIcon } from './createIcon.js';

export const Loader2 = createWpIcon('Loader2', [
  ['path', { d: 'M21 12a9 9 0 1 1-6.219-8.56', key: 'a' }],
]);
export const Type = createWpIcon('Type', [
  ['polyline', { points: '4 7 4 4 20 4 20 7', key: 'a' }],
  ['line', { x1: 9, x2: 15, y1: 20, y2: 20, key: 'b' }],
  ['line', { x1: 12, x2: 12, y1: 4, y2: 20, key: 'c' }],
]);
export const ListChecks = createWpIcon('ListChecks', [
  ['path', { d: 'm3 17 2 2 4-4', key: 'a' }],
  ['path', { d: 'm3 7 2 2 4-4', key: 'b' }],
  ['path', { d: 'M13 6h8', key: 'c' }],
  ['path', { d: 'M13 12h8', key: 'd' }],
  ['path', { d: 'M13 18h8', key: 'e' }],
]);
export const Coffee = createWpIcon('Coffee', [
  ['path', { d: 'M10 2v2', key: 'a' }],
  ['path', { d: 'M14 2v2', key: 'b' }],
  ['path', { d: 'M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1', key: 'c' }],
  ['path', { d: 'M6 2v2', key: 'd' }],
]);
